import React from "react";
import Select from "react-select";
import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'
// import TimePicker from 'react-time-picker';
// import DatePicker from "react-date-picker";
import DatePicker from 'react-datepicker'
import { CustomFields } from "../types/CustomFieldType";
import { getCustomFieldDataSelectLabel, getValueArray, parseDateForCustomDate } from "../util/FormatUtil";


interface GetFieldProps{
    val
    selectedItem
    handleChange
    fromSamples?
    patientSearchReadOnly?
    fromPatientMgmt?
    isRequired?
    readOnly?
}
interface GetFieldState{
    selectedItem
    rawDateInput
}
const GetField: React.FC<GetFieldProps> = ({
  val,
  selectedItem,
  handleChange,
  fromSamples,
  patientSearchReadOnly,
  fromPatientMgmt,
  isRequired,
  readOnly: readOnlyProp
}) => {
  // readOnlyProp undefined → field not in permissions table, use default patientSearchReadOnly logic
  // readOnlyProp false → field in permissions table and user has access, force editable
  // readOnlyProp true → field in permissions table and user lacks access, force read-only
  const isReadOnly = readOnlyProp !== undefined ? readOnlyProp : (patientSearchReadOnly && !fromPatientMgmt);
  const [localSelectedItem, setLocalSelectedItem] = React.useState(selectedItem);
  const [rawDateInput, setRawDateInput] = React.useState(
    selectedItem?.CustomFieldData && selectedItem.CustomFieldData[val.DisplayName]
      ? selectedItem.CustomFieldData[val.DisplayName]
      : ''
  );

  React.useEffect(() => {
    setLocalSelectedItem(selectedItem);
    setRawDateInput(
      selectedItem?.CustomFieldData && selectedItem.CustomFieldData[val.DisplayName]
        ? selectedItem.CustomFieldData[val.DisplayName]
        : ''
    );
  }, [selectedItem, val.DisplayName]);

  const getField = (val) => {
    let customFieldDataCopy = localSelectedItem?.CustomFieldData
      ? JSON.parse(JSON.stringify(localSelectedItem.CustomFieldData))
      : {};
    let fieldTypeID = val.FieldTypeID;

    if (fieldTypeID === CustomFields.TEXT_FIELD || fieldTypeID === CustomFields.EMAIL_FIELD) {
      return (
        <>
          <div className={"col-12 col-md-4"} data-toggle={'tooltip'} data-placement={'top'} title={val.Options.popoverText}>
            <label className={"col-form-label"} htmlFor={val.DisplayName} style={{ paddingTop: '0.5em' }}>
              {val.DisplayName}
              {isRequired ? <section className="text-danger d-inline-block px-1">*</section> : ''}
            </label>
          </div>
          <div className={fromSamples ? "col-12 col-md-8" : "col-12 col-md-8 pl-md-0 pr-md-1"} id={val.DisplayName}>
            <div className={fromSamples ? "row mr-md-2" : "row mr-md-0 ml-md-0"}>
              <div className="col-12 p-md-0">
                <input
                  type={"search"}
                  id={val.DisplayName.replaceAll(' ', '')}
                  readOnly={isReadOnly}
                  maxLength={val.Options.maxLength}
                  aria-label={val.DisplayName}
                  aria-required={val.Options.isRequired}
                  className={'form-control'}
                  value={
                    localSelectedItem?.CustomFieldData && localSelectedItem.CustomFieldData[val.DisplayName]
                      ? typeof localSelectedItem.CustomFieldData[val.DisplayName] === 'object'
                        ? localSelectedItem.CustomFieldData[val.DisplayName].answer
                        : localSelectedItem.CustomFieldData[val.DisplayName]
                      : ''
                  }
                  autoComplete="off"
                  onChange={(e) => {
                    customFieldDataCopy[val.DisplayName] = { answer: e.target.value, serviceType: val.Options.serviceType };
                    const updated = {
                      ...localSelectedItem,
                      CustomFieldData: customFieldDataCopy
                    };
                    setLocalSelectedItem(updated);
                    handleChange(updated);
                  }}
                />
              </div>
            </div>
          </div>
        </>
      );
    } else if (fieldTypeID === CustomFields.SELECT_FIELD) {
      return (
        <>
          <div className={"col-12 col-md-4"} data-toggle={'tooltip'} data-placement={'top'} title={val.Options.popoverText}>
            <label className={"col-form-label"} htmlFor={val.DisplayName} style={{ paddingTop: '0.5em' }}>
              {val.DisplayName}
              {isRequired ? <section className="text-danger d-inline-block px-1">*</section> : ''}
            </label>
          </div>
          <div className={fromSamples ? "col-12 col-md-8" : "col-12 col-md-8 pl-md-0 pr-md-1"} id={val.DisplayName}>
            <div className={fromSamples ? "row mr-2" : "row mr-0 ml-0"}>
              <div className="col-12 p-0">
                <Select
                  id={val.ID}
                  isDisabled={isReadOnly}
                  isMulti={val.Options.isMulti}
                  aria-label={val.DisplayName}
                  isSearchable={true}
                  placeholder={<div className="accessibilityText">Please Select...</div>}
                  className={"state_select"}
                  options={val.Options.options}
                  value={
                    localSelectedItem?.CustomFieldData && localSelectedItem.CustomFieldData[val.DisplayName]
                      ? getCustomFieldDataSelectLabel(
                        typeof localSelectedItem.CustomFieldData[val.DisplayName] === 'object'
                          ? localSelectedItem.CustomFieldData[val.DisplayName].answer
                          : localSelectedItem.CustomFieldData[val.DisplayName],
                        val
                      )
                      : ''
                  }
                  onChange={(e) => {
                    customFieldDataCopy[val.DisplayName] = val.Options.isMulti
                      ? { answer: getValueArray(e), serviceType: val.Options.serviceType }
                      : { answer: e.value, serviceType: val.Options.serviceType };
                    const updated = {
                      ...localSelectedItem,
                      CustomFieldData: customFieldDataCopy
                    };
                    setLocalSelectedItem(updated);
                    handleChange(updated);
                  }}
                />
              </div>
            </div>
          </div>
        </>
      );      
    } else if (fieldTypeID === CustomFields.DATE_FIELD) {
      return (
        <>
          <div className={"col-12 col-md-4"} data-toggle={'tooltip'} data-placement={'top'} title={val.Options.popoverText}>
            <label id={val.DisplayName.replaceAll(' ', '')} className={"col-form-label"} htmlFor={val.DisplayName} style={{ paddingTop: '0.5em' }}>
              {val.DisplayName}
              {isRequired ? <section className="text-danger d-inline-block px-1">*</section> : ''}
            </label>
          </div>
          <div className={fromSamples ? "col-12 col-md-8 pl-0" : "col-12 col-md-8 pl-3 pl-md-0 pr-md-1"} id={val.DisplayName}>
            <div className={fromSamples ? "row mr-2" : "row mr-0 ml-0"}>
              <div className="col-12 p-0">
                <input
                  id={val.ID}
                  disabled={isReadOnly}
                  readOnly={isReadOnly}
                  aria-labelledby={val.DisplayName.replaceAll(' ', '')}
                  className={"form-control"}
                  autoComplete={"off"}
                  type={"date"}
                  onChange={(e) => {
                    setRawDateInput(e.target.value);
                  }}
                  onBlur={(e) => {
                    const value = e.target.value;
                    const datePattern = /^\d{4}-\d{2}-\d{2}$/;
                    if (datePattern.test(value)) {
                      let customFieldDataCopy = { ...localSelectedItem.CustomFieldData };
                      customFieldDataCopy[val.DisplayName] = { answer: value, serviceType: val.Options.serviceType };
                      const updated = {
                        ...localSelectedItem,
                        CustomFieldData: customFieldDataCopy
                      };
                      setLocalSelectedItem(updated);
                      setRawDateInput(value);
                      handleChange(updated);
                    } else {
                      console.error('Invalid date format:', value);
                      setRawDateInput('');
                    }
                  }}
                  value={
                    rawDateInput
                      ? typeof rawDateInput === 'object'
                        ? parseDateForCustomDate(rawDateInput.answer, false)
                        : parseDateForCustomDate(rawDateInput, false)
                      : ''
                  }
                />
              </div>
            </div>
          </div>
        </>
      );
    } else if (fieldTypeID === CustomFields.TEXTAREA_FIELD) {
      return (
        <>
          <div className={"col-12 col-md-4"} data-toggle={'tooltip'} data-placement={'top'} title={val.Options.popoverText}>
            <label className={"col-form-label"} htmlFor={val.DisplayName} style={{ paddingTop: '0.5em' }}>
              {val.DisplayName}
              {isRequired ? <section className="text-danger d-inline-block px-1">*</section> : ''}
            </label>
          </div>
          <div className={fromSamples ? "col-12 col-md-8" : "col-12 col-md-8 pl-md-0 pr-md-1"} id={val.DisplayName}>
            <div className={fromSamples ? "row mr-2" : "row mr-0 ml-0"}>
              <div className="col-12 p-0">
                <textarea
                  id={val.ID}
                  readOnly={isReadOnly}
                  maxLength={val.Options.maxLength}
                  rows={3}
                  className={'form-control'}
                  aria-label={val.DisplayName}
                  aria-required={val.Options.isRequired}
                  value={
                    localSelectedItem?.CustomFieldData && localSelectedItem.CustomFieldData[val.DisplayName]
                      ? typeof localSelectedItem.CustomFieldData[val.DisplayName] === 'object'
                        ? localSelectedItem.CustomFieldData[val.DisplayName].answer
                        : localSelectedItem.CustomFieldData[val.DisplayName]
                      : ''
                  }
                  autoComplete="off"
                  onChange={(e) => {
                    customFieldDataCopy[val.DisplayName] = { answer: e.target.value, serviceType: val.Options.serviceType };
                    const updated = {
                      ...localSelectedItem,
                      CustomFieldData: customFieldDataCopy
                    };
                    setLocalSelectedItem(updated);
                    handleChange(updated);
                  }}
                />
              </div>
            </div>
            <div className="row pt-1 pr-3 justify-content-end">
              <div className={
                localSelectedItem?.CustomFieldData &&
                localSelectedItem.CustomFieldData[val.DisplayName] &&
                localSelectedItem.CustomFieldData[val.DisplayName].answer.length > 0
                  ? 'visible'
                  : 'invisible'
              }>
                <div style={{ fontSize: '0.8em' }}>
                  {localSelectedItem?.CustomFieldData &&
                    localSelectedItem.CustomFieldData[val.DisplayName] &&
                    localSelectedItem.CustomFieldData[val.DisplayName].answer.length}
                  /{val.Options.maxLength}
                </div>
              </div>
            </div>
          </div>
        </>
      );
    } else if (fieldTypeID === CustomFields.NUMBER_FIELD) {
      return (
        <>
          <div className={"col-12 col-md-4"} data-toggle={'tooltip'} data-placement={'top'} title={val.Options.popoverText}>
            <label className={"col-form-label"} htmlFor={val.DisplayName} style={{ paddingTop: '0.5em' }}>
              {val.DisplayName}
              {isRequired ? <section className="text-danger d-inline-block px-1">*</section> : ''}
            </label>
          </div>
          <div className={fromSamples ? "col-12 col-md-8" : "col-12 col-md-8 pl-md-0 pr-md-1"} id={val.DisplayName}>
            <div className={fromSamples ? "row mr-2" : "row mr-0 ml-0"}>
              <div className="col-12 p-0">
                <input
                  type={"number"}
                  id={val.ID}
                  readOnly={isReadOnly}
                  min={val.Options.min}
                  max={val.Options.max}
                  aria-label={val.DisplayName}
                  aria-required={val.Options.isRequired}
                  className={'form-control'}
                  value={
                    localSelectedItem?.CustomFieldData && localSelectedItem.CustomFieldData[val.DisplayName]
                      ? typeof localSelectedItem.CustomFieldData[val.DisplayName] === 'object'
                        ? localSelectedItem.CustomFieldData[val.DisplayName].answer
                        : localSelectedItem.CustomFieldData[val.DisplayName]
                      : ''
                  }
                  autoComplete="off"
                  onChange={(e) => {
                    customFieldDataCopy[val.DisplayName] = { answer: e.target.value, serviceType: val.Options.serviceType };
                    const updated = {
                      ...localSelectedItem,
                      CustomFieldData: customFieldDataCopy
                    };
                    setLocalSelectedItem(updated);
                    handleChange(updated);
                  }}
                />
              </div>
            </div>
          </div>
        </>
      );
    } else if (fieldTypeID === CustomFields.PHONE_FIELD) {
      return (
        <>
          <div className={"col-12 col-md-4"} data-toggle={'tooltip'} data-placement={'top'} title={val.Options.popoverText}>
            <label className={"col-form-label"} htmlFor={val.DisplayName} style={{ paddingTop: '0.5em' }}>
              {val.DisplayName}
              {isRequired ? <section className="text-danger d-inline-block px-1">*</section> : ''}
            </label>
          </div>
          <div className={fromSamples ? "col-12 col-md-8" : "col-12 col-md-8 pl-md-0 pr-md-1"} id={val.DisplayName}>
            <div className={fromSamples ? "row mr-2" : "row mr-0 ml-0"}>
              <div className="col-12 p-0">
                <PhoneInput
                  id={val.ID}
                  readOnly={isReadOnly}
                  placeholder="Enter phone number"
                  defaultCountry="US"
                  aria-label={val.DisplayName}
                  value={
                    localSelectedItem?.CustomFieldData && localSelectedItem.CustomFieldData[val.DisplayName]
                      ? typeof localSelectedItem.CustomFieldData[val.DisplayName] === 'object'
                        ? localSelectedItem.CustomFieldData[val.DisplayName].answer
                        : localSelectedItem.CustomFieldData[val.DisplayName]
                      : ''
                  }
                  onChange={(e) => {
                    customFieldDataCopy[val.DisplayName] = { answer: e, serviceType: val.Options.serviceType };
                    const updated = {
                      ...localSelectedItem,
                      CustomFieldData: customFieldDataCopy
                    };
                    setLocalSelectedItem(updated);
                    handleChange(updated);
                  }}
                />
              </div>
            </div>
          </div>
        </>
      );
    } else if (fieldTypeID === CustomFields.CHECKBOX_FIELD) {
      return (
        <>
          <div className={"col-12 col-md-4"} data-toggle={'tooltip'} data-placement={'top'} title={val.Options.popoverText}>
            <label className={"col-form-label form-check-label"} htmlFor={val.DisplayName} style={{ paddingTop: '0.5em' }}>
              {val.DisplayName}
              {isRequired ? <section className="text-danger d-inline-block px-1">*</section> : ''}
            </label>
          </div>
          <div className={fromSamples ? "col-12 col-md-8" : "col-12 col-md-8 pl-md-0 pr-md-1"} id={val.DisplayName}>
            <div className={fromSamples ? "row mr-2" : "row mr-0 ml-0"}>
              <div className="col-12 p-0">
                <input
                  type={"checkbox"}
                  className={"form-control"}
                  style={{ width: '1.5em', height: '1.5em', marginTop: '0.5em' }}
                  id={val.ID}
                  readOnly={isReadOnly}
                  aria-label={val.DisplayName}
                  aria-required={val.Options.isRequired}
                  checked={
                    localSelectedItem?.CustomFieldData && localSelectedItem.CustomFieldData[val.DisplayName]
                      ? typeof localSelectedItem.CustomFieldData[val.DisplayName] === 'object'
                        ? localSelectedItem.CustomFieldData[val.DisplayName].answer
                        : localSelectedItem.CustomFieldData[val.DisplayName]
                      : false
                  }
                  onChange={(e) => {
                    customFieldDataCopy[val.DisplayName] = { answer: e.target.checked, serviceType: val.Options.serviceType };
                    const updated = {
                      ...localSelectedItem,
                      CustomFieldData: customFieldDataCopy
                    };
                    setLocalSelectedItem(updated);
                    handleChange(updated);
                  }}
                />
              </div>
            </div>
          </div>
        </>
      );
    } else if(fieldTypeID === CustomFields.DATETIME_FIELD){
            return(
                <>
                    <div className={"col-12 col-md-4"} data-toggle={'tooltip'} data-placement={'top'} title={val.Options.popoverText}>
                        <label id={val.DisplayName.replaceAll(' ', '')} className={"col-form-label"} htmlFor={val.DisplayName} style={{paddingTop: '0.5em', }}>{val.DisplayName}{isRequired ? <section className="text-danger d-inline-block px-1">*</section> : ''}</label>
                    </div>
                    <div className={fromSamples ? "col-12 col-md-8 pl-0" : "col-12 col-md-8 pl-3 pl-md-0 pr-md-1"} id={val.DisplayName}>
                        <div className={fromSamples ? "row mr-2" : "row mr-0 ml-0"}>
                            <div className="col-12 p-0">
                            <input 
                                id={val.ID}
                                disabled={isReadOnly}
                                readOnly={isReadOnly}
                                aria-labelledby={val.DisplayName.replaceAll(' ', '')} 
                                className={"form-control"}
                                autoComplete={"off"}
                                type={"datetime-local"}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    setRawDateInput(value);
                                }}
                                onBlur={(e) => {
                                    const value = e.target.value;

                                     // Regular expression to check for YYYY-MM-DD format
                                    const datePattern = /^\d{4}-\d{2}-\d{2}$/;

                                    if (datePattern.test(value)) {
                                        // If the date format is correct, update the state
                                        let customFieldDataCopy = { ...localSelectedItem.CustomFieldData };
                                        customFieldDataCopy[val.DisplayName] = {answer: value, serviceType: val.Options.serviceType};

                                        setLocalSelectedItem(prevState => ({
                                            ...prevState,
                                            CustomFieldData: customFieldDataCopy
                                        }));
                                        setRawDateInput(value);
                                        handleChange(localSelectedItem);
                                    } else {
                                        console.error('Invalid date format:', value);
                                        setRawDateInput('');
                                    }
                                }}
                                value={rawDateInput ? typeof rawDateInput === 'object' ? parseDateForCustomDate(rawDateInput.answer, true) : parseDateForCustomDate(rawDateInput, true) : ''}
                            />
                            </div>
                        </div>
                    </div>
                </>
            )
        }
    return null;
  };

  return <>{getField(val)}</>;
};

export default GetField;